const flags = {
  "": "",
  searchterm: "searchterm",
  contactChatbot: "contactChatBot",
  forceAirgap: "forceAirgap"
}

export type Flag = keyof typeof flags

export const getFlag = (): Flag => {
  if (typeof window !== "undefined") {
    const queryParams =
      typeof window !== "undefined"
        ? new URLSearchParams(window?.location?.search)
        : null
    const flag = queryParams?.get("flag") as Flag

    if (flags[flag]) {
      return flag
    }
  }

  return ""
}